import {
  clearSessionItem,
  readSessionItemWithLocalFallback,
  writeSessionItem,
} from './session-storage'

const ADMIN_TOKEN_KEY = 'statureboost_admin_token_v1'

export function getAdminToken(): string {
  return readSessionItemWithLocalFallback(ADMIN_TOKEN_KEY) ?? ''
}

export function setAdminToken(token: string): void {
  writeSessionItem(ADMIN_TOKEN_KEY, token)
}

export function clearAdminToken(): void {
  clearSessionItem(ADMIN_TOKEN_KEY)
}
